{
    "ai_modal_title_1": "Metninizi yapay zeka ile geliştirin",
    "ai_modal_title_2": "Yapay zeka kullanarak yeni metin oluşturun",
    "ai_description": "Metinlerinizi geliştirmek için yapay zeka içerik oluşturma araçlarını kullanın.",
    "ai_learn_more": "Daha fazla bilgi",
    "ai_copy_text": "Metni kopyalayın",
    "ai_describe_your_text": "Metninizin ne hakkında olması gerektiğini açıklayın",
    "ai_describe_your_text_example": "For example, a small description for a craft shop...",
    "ai_new_request": "Yeni talep oluştur",
    "ai_create_text": "Metin oluştur",
    "ai_apply_text": "Metin uygula",
    "ai_try_one_more": "Tekrar deney",
    "ai_correct_errors": "Hataları düzelt",
    "ai_make_longer": "Genişletme",
    "ai_make_shorter": "Kısalt",
    "ai_simplify": "Basitleştir",
    "ai_business_tone": "Resmi",
    "ai_ceremonial_tone": "Eğlenceli",
    "ai_fun_tone": "Neşeli",
    "ai_friendly_tone": "Dostça",
    "ai_change_tone": "Ses tonunu değiştir",
    "ai_improve_text": "Metni iyileştir",
    "ai_words_number": "Kelime sayısı:",
    "ai_translate": "Çevir",
    "ai_translate_to_ru": "Rusça'ya çevir",
    "ai_translate_to_en": "İngilizce'ye çevir",
    "ai_add_creativity": "Yaratıcılık kat",
    "ai_text_too_large": "Metniniz yapay zekayı kullanmak için çok uzun. Yapay zeka yardımıyla metni kısaltın veya istediğiniz konuda yeni bir metin oluşturun.",
    "ai_translate_to_ua": "Ukraynaca'ya çevir",
    "ai_translate_to_es": "İspanyolca'ya çevir",
    "ai_translate_to_pt": "Portekizce'ye çevir",
    "ai_translate_to_tr": "Türkçe'ye çevir",
    "ai_translate_to_fr": "Fransızca'ya çevir",
    "ai_translate_to_de": "Almanca'ya çevir",
    "ai_translate_to_it": "İtalyanca'ya çevir",
    "ai_translate_to_pl": "Lehçe'ye çevir",
    "ai_free_request_error": "Ücretsiz talepler sona erdi",
    "ai_free_request_number": "Talep numarası: {{ FREE_KEY }} / {{ FREE_KEY_LIMIT }}",
    "ai_request_limit_info": "200 adede kadar ücretsiz AI aracı isteği kullanabilirsiniz. Daha fazla istekte bulunmak için, hesap ayarlarınızda API anahtarlarınızı AI sağlayıcısına etkinleştirin.",
    "cancel": "İptal",
    "gpt_error_quota": "Вы израсходовали доступное количество запросов к API. Чтобы использовать инструменты ИИ и дальше, проверьте текущий лимит или пополните баланс в настройках учетной записи OpenAI.",
    "ai_generated_disclaimer": "Oluşturulan metinden siz sorumlusunuz. Yayınlamadan önce gözden geçirin."
}
